export default __webpack_public_path__ + "static/media/amenities_image_mobile.244a7e1e.png";